'use strict';

var Sugar = require('sugar-core'),
    dateRelative = require('./internal/dateRelative');

Sugar.Date.defineInstance({

  'relative': function(date, localeCode, fn) {
    return dateRelative(date, null, localeCode, fn);
  }

});

module.exports = Sugar.Date.relative;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/relative.js
// module id = 270
// module chunks = 1